import React from 'react';
interface ProgressBarProps {
  currentDay: number;
  totalDays: number;
  label?: string;
}
const ProgressBar: React.FC<ProgressBarProps> = ({
  currentDay,
  totalDays,
  label
}) => {
  const percentage = Math.min(Math.round(currentDay / totalDays * 100), 100);
  return <div className="w-full" data-id="element-66">
      {label && <div className="text-sm font-medium text-gray-700 mb-1" data-id="element-67">{label}</div>}
      <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-68">
        <div className="h-full bg-gradient-to-r from-[#E91E63] to-[#9C27B0] rounded-full transition-all duration-500 ease-in-out" style={{
        width: `${percentage}%`
      }} data-id="element-69"></div>
      </div>
      <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-70">
        <span data-id="element-71">Día {currentDay}</span>
        <span data-id="element-72">{percentage}% completado</span>
      </div>
    </div>;
};
export default ProgressBar;